"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazily = exports.partial = void 0;
const ramda_1 = require("ramda");
const partial = (staticArgs, f) => function (...restArgs) {
    return f(...[...staticArgs, ...restArgs]);
};
exports.partial = partial;
const lazily = (fn) => (0, ramda_1.memoizeWith)((0, ramda_1.always)("1"), fn);
exports.lazily = lazily;
//# sourceMappingURL=fpHelpers.js.map